export { State, initialState } from './traduzioni.state';
export * from './traduzioni.actions';
export { traduzioniReducer } from './traduzioni.reducer';